import { fireLinkTag } from './tagManager';

export const tagAltImagesClicked = () => {
  fireLinkTag({
    event_name: 'alt_image_clicked',
    link_name: 'alt_image_clicked',
  });
};

export const tagLastAltImagesClicked = () => {
  fireLinkTag({
    event_name: 'alt_last_image_clicked',
    link_name: 'alt_last_image_clicked',
  });
};

// Event for more products like this
export const tagImageMoreLikeClicked = (currentPage: number) => {
  const eventName = `more like this:pdp image ${currentPage}`;
  fireLinkTag({
    event_name: eventName,
    link_name: eventName,
  });
};

// Event for see more/fewer sizes
export const tagImageZoom = (isZoomedIn: boolean) => {
  const eventName = isZoomedIn ? 'pinch to zoom = Zoom In' : 'pinch to zoom = Zoom out';

  fireLinkTag({
    event_name: eventName,
    link_name: eventName,
  });
};

// Event for see more/fewer sizes
export const tagImageClicked = (index: number) => {
  const eventName = `pdp image ${index} full screen`;

  fireLinkTag({
    event_name: eventName,
    link_name: eventName,
  });
};

// Event for overlay opened using fullscreen icon
export const tagOverlayOpened = () => {
  const eventName = 'pdp image zoom';

  fireLinkTag({
    event_name: eventName,
    link_name: eventName,
  });
};
